import styled from "styled-components";

interface Thead {
  title: string;
  width: string;
  key: string;
}

interface TableProps {
  children: React.ReactNode;
  thead: Thead[];
};

export default function Table({ children, thead }: TableProps) {
  return (
    <>
      <CommonTable>
        <thead>
          <tr>
            {thead.map(trObj => (
              <Th key={trObj.key} $width={trObj.width}>{trObj.key === "check" ? <input type="checkbox" /> : trObj.title}</Th>
            ))}
          </tr>
        </thead>

        <CommonTbody>
          {children}
        </CommonTbody>
      </CommonTable>
    </>
  );
}

const CommonTable = styled.table`
  width: 100%;
  border-spacing: 0;
`;

const Th = styled.th<{ $width: string; }>`
  color: #545454;
  font-size: 0.875rem;
  font-weight: 600;
  background-color: #F8F9FA;
  width: ${({ $width }) => $width};
  height: 2.5rem;
  border-top: 1px solid #E6E9ED;
  border-bottom: 1px solid #E6E9ED;
`;

const CommonTbody = styled.tbody`
  td {
    color: #666;
    text-align: center;
    font-size: 1rem;
    font-weight: 400;
    height: 3.75rem;
    border-bottom: 1px solid #F5F5F5;
  }
`;